import { AnyObject } from '@hb/shared'
import { BaseDataView, BaseDataViewList } from './BaseDataView'
import { GenericEditModal } from './GenericEditModal'
import { DataViewListProps, DataViewProps } from './types'

export const DataView = (props: DataViewProps) => (
  <BaseDataView EditModalComponent={GenericEditModal} {...props} />
)

export const DataViewList = <T extends AnyObject>(props: DataViewListProps<T>) => (
  <BaseDataViewList EditModalComponent={GenericEditModal} {...props} />
)
